export default "__VITE_PUBLIC_ASSET__816e35b6__"